// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.withdraw-as-supplier[data-v-daa991fa] {\n  padding: 20px 30px 30px;\n}\n.withdraw-as-supplier__text[data-v-daa991fa] {\n  padding-bottom: 15px;\n}\n.withdraw-as-supplier__textarea[data-v-daa991fa] {\n  height: 100px;\n}\n.withdraw-as-supplier__btn[data-v-daa991fa] {\n  margin-top: 30px;\n}\n.withdraw-as-supplier__select[data-v-daa991fa] {\n  margin: 10px 0;\n}\n.withdraw-as-supplier__radio[data-v-daa991fa] {\n  margin: 10px 10px 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
